import { Base } from 'active-resource';
import APILibrary, { ClassExtender, GConstructor, GenerateResource } from './APILibrary';
import { VideoAskQuestionResource } from './VideoAskQuestion';

/**
 * Relationship classes
 */
export class VideoAskAnswerAttributes {
  contactShareUrl: string = null;
  gifUrl: string = null;
}

export class VideoAskBelongsTo {}

export class VideoAskAnswerHasOne {
  videoAskQuestion: () => VideoAskQuestionResource = () => new VideoAskQuestionResource();
}

export class VideoAskAnswerHasMany {}

/**
 * Utility interfaces
 */
export interface VideoAskAnswerMethods {}

export interface VideoAskAnswerInterface
  extends VideoAskAnswerAttributes,
    VideoAskAnswerHasOne,
    VideoAskType {}

type VideoAskType = GConstructor<VideoAskAnswerInterface>;

export interface VideoAskAnswerResource
  extends Base<VideoAskAnswerAttributes>,
    VideoAskAnswerInterface,
    VideoAskAnswerMethods {}

/**
 * Resource methods
 */
const BaseClass = () =>
  GenerateResource<VideoAskAnswerAttributes>({
    queryName: 'video_ask_answers',
    className: 'VideoAskAnswer',
    AttributesClass: VideoAskAnswerAttributes,
    HasOneClasses: [
      {
        Klass: VideoAskAnswerHasOne,
      },
    ],
  });

export const VideoAskAnswerResourceClass = <TBase extends VideoAskType>(
  BaseConstructor: TBase,
): TBase => class extends BaseConstructor implements VideoAskAnswerMethods {};

export class VideoAskAnswerResource extends ClassExtender<VideoAskAnswerInterface>(
  BaseClass,
  VideoAskAnswerResourceClass,
) {}

/**
 * Resource instance
 */
export const VideoAskAnswer =
  APILibrary.createResource<VideoAskAnswerResource>(VideoAskAnswerResource);
